import api from '../../utils/api'

import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormClient from './Form/FormClient'

function NewClient({ btCancelAction, handleOnSuccess , sellerEnabled}) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()
    const [load, setLoad] = useState(true)

    async function registerClient(client) {
        let msgType = 'success'

        const data = await api.post('/client/new', client, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }

    return (
        <section>
            {load &&
                <FormClient title="Cadastrar Cliente" sellerEnabled={sellerEnabled} handleSubmit={registerClient} btCancelAction={btCancelAction} btnText="Salvar" />
            }
        </section>
    )
}

export default NewClient